
import React, { createContext, useContext, useEffect, useState } from 'react';
import io from 'socket.io-client';
import { useAuth } from './AuthContext';

const SocketContext = createContext();

export function useSocket() {
    return useContext(SocketContext);
}

export function SocketProvider({ children }) {
    const [socket, setSocket] = useState(null);
    const { usuario, isLogado } = useAuth();

    useEffect(() => {
        if (isLogado && usuario) {
            // Conecta apenas se estiver logado
            const socketUrl = (import.meta.env.VITE_API_URL || 'http://localhost:3001').replace(/\/api$/, '');
            const newSocket = io(socketUrl, {
                withCredentials: true
            });

            newSocket.on('connect', () => {
                console.log('🟢 Socket conectado:', newSocket.id);
                // Entrar na "sala pessoal" do usuário para receber notificações
                newSocket.emit('join_user', usuario.id);
            });

            newSocket.on('disconnect', () => {
                console.log('🔴 Socket desconectado');
            });

            setSocket(newSocket);

            return () => newSocket.close();
        } else {
            // Se deslogar, fecha o socket
            if (socket) {
                socket.close();
                setSocket(null);
            }
        }
    }, [isLogado, usuario?.id]); // Recria se o usuário mudar

    const value = {
        socket
    };

    return (
        <SocketContext.Provider value={value}>
            {children}
        </SocketContext.Provider>
    );
}
